import { Spinner } from "react-bootstrap";
import styled from "styled-components";

export const LoadingComponent = styled(Spinner)`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 20px;
  width: 50px;
  height: 50px;
`;